import React, { Component } from 'react';
import _cloneDeep from 'lodash.clonedeep';
import memoizeOne from 'memoize-one';
import uuid from 'uuid/v4';

import { ROLE_MAP } from '@shootsta/common-domain-data';







import {
  getMembers,
  getLinkSharingSettings,
  resolveProfileImages,
  getPrivateResourceSettings } from
'../utils';
import { CollaborationProvider as CollaborationProviderContext } from '../contexts/CollaborationContext';
import CollaborationModal from './CollaborationModal';
import PrivateSettingsModal from './PrivateSettingsModal';
import ShareModal from './ShareModal';
import CollaborationModalV5 from './CollaborationModalV5/components/CollaboratorsModalV5';

function getDraftMembers(collaborators = []) {
  return _cloneDeep(collaborators).map((item) => ({
    ...item,
    draftMemberId: item.resourceRoleAssignmentId || uuid(),
    draftSubMemberId: item.resourceRoleAssignmentId || uuid()
  }));
}





































export default class CollaborationProvider extends Component


{
  getProviderValue = memoizeOne((members, privateSettings, resourceName, linkSharingSettings) => ({
    showCollaborationModal: this.showCollaborationModal,
    hideCollaborationModal: this.hideCollaborationModal,
    showPrivateSettingsModal: this.showPrivateSettingsModal,
    hidePrivateSettingsModal: this.hidePrivateSettingsModal,
    showShareModal: this.showShareModal,
    hideShareModal: this.hideShareModal,
    fetchCollaborationData: this.fetchCollaborationData,
    resourceName,
    members,
    privateSettings,
    linkSharingSettings
  }));

  constructor(props) {
    super(props);

    this.state = {};
  }

  fetchResourceRoles = async (organisationId) => {
    const { getResourceRoles } = this.props;

    const { data: { getRoles = [] } = {}, error } = await getResourceRoles(
      organisationId
    );

    if (error) {
      return { error };
    }

    const roles = getRoles.map((role) => ({
      ...role,
      description: ROLE_MAP[role.name]
    }));

    const noneRole = roles.find(({ name }) => name === 'NONE');
    const guestRole = roles.find(({ name }) => name === 'GUEST');

    return { roles, guestRole, noneRole };
  };

  fetchRoleAssignments = async (
  resourceId,
  resourceSubId) =>
  {
    const { getRoleAssignments, resourceSubName } = this.props;

    const {
      data: { getRoleAssignments: collaborators = [] } = {},
      error
    } = await getRoleAssignments(resourceId);

    if (error) {
      return { collaborators: [], error };
    }

    if (resourceSubId && resourceSubName) {
      const {
        data: { getRoleAssignments: subCollaborators = [] } = {},
        error: subError
      } = await getRoleAssignments(resourceSubId);

      if (subError) {
        return { collaborators, subCollaborators: [], subError };
      }

      return { collaborators, subCollaborators };
    }

    return { collaborators };
  };

  showCollaborationModal = () => {
    this.setState({
      collaborationModalVisible: true,
      shareModalVisible: false,
      privateSettingsModalVisible: false
    });
  };

  hideCollaborationModal = () => {
    const { members, subResourceMembers } = this.state;

    this.setState({
      collaborationModalVisible: false,
      draftMembers: getDraftMembers(members),
      draftSubMembers: getDraftMembers(subResourceMembers)
    });
  };

  showShareModal = () => {
    this.setState({
      shareModalVisible: true,
      collaborationModalVisible: false,
      privateSettingsModalVisible: false
    });
  };

  hideShareModal = () => {
    const { linkSharingSettings } = this.state;

    this.setState({
      draftLinkSharingSettings: {
        ...linkSharingSettings
      },
      shareModalVisible: false
    });
  };

  showPrivateSettingsModal = () => {
    this.setState({
      privateSettingsModalVisible: true,
      collaborationModalVisible: false,
      shareModalVisible: false
    });
  };

  hidePrivateSettingsModal = () => {
    this.setState({ privateSettingsModalVisible: false });
  };

  fetchCollaborationData = async (organisationId) => {
    this.setState({
      organisationId,
      linkSharingSettings: void 0,
      draftLinkSharingSettings: void 0,
      roles: void 0,
      guestRole: void 0
    });

    const { resourceId, resourceSubId, apiClient } = this.props;

    const [
    { error: rolesError, roles, guestRole, noneRole },
    {
      error: collaboratorsError,
      subError: subCollaboratorsError,
      collaborators,
      subCollaborators
    }] =
    await Promise.all([
    this.fetchResourceRoles(organisationId),
    this.fetchRoleAssignments(resourceId, resourceSubId)]
    );

    if (rolesError || collaboratorsError || resourceSubId && subCollaboratorsError) {
      return;
    }

    const members = await getMembers(collaborators, organisationId, apiClient);
    const fetchSubResourceMembers = await getMembers(subCollaborators, organisationId, apiClient);

    const draftSubMembers = subCollaborators ?
    getDraftMembers(fetchSubResourceMembers) :
    [];

    const linkSharingSettings = getLinkSharingSettings(
      collaborators,
      guestRole,
      noneRole
    );

    const privateSettings = getPrivateResourceSettings(collaborators);

    this.setState({
      draftMembers: getDraftMembers(members),
      draftSubMembers,
      subResourceMembers: subCollaborators ?
      await getMembers(subCollaborators, organisationId, apiClient) :
      [],
      members,
      roles,
      guestRole,
      noneRole,
      deletedMembers: new Set(),
      deletedSubMembers: new Set(),
      linkSharingSettings,
      privateSettings,
      draftLinkSharingSettings: {
        ...linkSharingSettings
      }
    });
  };

  onUpdateAndSaveMembers = async () => {
    const {
      draftMembers,
      draftSubMembers,
      deletedMembers,
      deletedSubMembers,
      organisationId
    } = this.state;
    const {
      updateRoleAssignments,
      resourceId,
      resourceName,
      apiClient,
      resourceSubId,
      resourceSubName
    } = this.props;

    const upsertAssignments = draftMembers ?
    draftMembers.map(
      ({ resourceRoleAssignmentId, userId, teamId, role: { roleId } }) => ({
        resourceRoleAssignmentId,
        userId,
        teamId,
        roleId
      })
    ) :
    [];

    const upsertSubAssignments = draftSubMembers ?
    draftSubMembers.map(
      ({ resourceRoleAssignmentId, userId, teamId, role: { roleId } }) => ({
        resourceRoleAssignmentId,
        userId,
        teamId,
        roleId
      })
    ) :
    [];

    const deletedAssignmentIds = deletedMembers ?
    [...deletedMembers].map(
      ({ resourceRoleAssignmentId }) => resourceRoleAssignmentId
    ) :
    [];

    const deletedSubAssignmentIds = deletedSubMembers &&
    [...deletedSubMembers].filter(Boolean).length ?
    [...deletedSubMembers].filter(Boolean).map(
      ({ resourceRoleAssignmentId }) => resourceRoleAssignmentId
    ) :
    [];

    const promises = [
    updateRoleAssignments({
      resourceId,
      resourceType: resourceName,
      assignmentsToUpsert: upsertAssignments,
      assignmentIdsToDelete: deletedAssignmentIds
    })];


    if (resourceSubId && resourceSubName) {
      promises.push(
        updateRoleAssignments({
          resourceId: resourceSubId,
          resourceType: resourceSubName,
          assignmentsToUpsert: upsertSubAssignments,
          assignmentIdsToDelete: deletedSubAssignmentIds
        })
      );
    }

    const [mainResponse, subResponse] = await Promise.all(promises);

    const { data, error } = mainResponse;
    const { data: subData, error: subError } = subResponse || {};

    if (error || resourceSubId && subError) {
      return;
    }

    const { updateRoleAssignments: newAssignments } = data || {};
    const { updateRoleAssignments: newSubAssignments } = subData || {};

    const newMembers = await getMembers(
      newAssignments,
      organisationId,
      apiClient
    );

    const newSubMembers = await getMembers(
      newSubAssignments,
      organisationId,
      apiClient
    );

    this.setState({
      members: newMembers,
      draftMembers: getDraftMembers(newMembers),
      subResourceMembers: newSubMembers,
      draftSubMembers: getDraftMembers(newSubMembers),
      deletedMembers: new Set(),
      deletedSubMembers: new Set()
    });
  };

  onUpdatePrivateSettings = async () => {
    const {
      updateRoleAssignments,
      resourceId,
      resourceName,
      resourceSubId,
      resourceSubName
    } = this.props;

    const {
      privateSettings: { isPrivate, resourceRoleAssignmentId },
      noneRole,
      organisationId
    } = this.state;

    if (isPrivate) {
      await updateRoleAssignments({
        assignmentIdsToDelete: [resourceRoleAssignmentId],
        resourceId,
        resourceType: 'Video'
      });

      return void this.setState({
        privateSettings: {
          canSearch: false,
          public: false,
          isPrivate: false,
          organisation: void 0,
          role: {},
          resourceRoleAssignmentId: void 0
        },
        privateSettingsModalVisible: false
      });
    }

    const newPrivateSettings = {
      roleId: noneRole.roleId,
      isPrivate: true,
      organisationId
    };

    const mainRequest = updateRoleAssignments({
      assignmentsToUpsert: [newPrivateSettings],
      resourceId,
      resourceType: resourceName
    });

    const subRequest = resourceSubId && resourceSubName ?
    updateRoleAssignments({
      assignmentsToUpsert: [newPrivateSettings],
      resourceId: resourceSubId,
      resourceType: resourceSubName
    }) :
    null;

    const [mainResponse, subResponse] = await Promise.all([
    mainRequest,
    subRequest]
    );

    const { data: mainData, error: mainError } = mainResponse;
    const { data: subData, error: subError } = subResponse || {};

    if (mainError || resourceSubId && subError) {
      return void null;
    }

    const mainRoleAssignments = mainData?.updateRoleAssignments || [];
    const subRoleAssignments = subData?.updateRoleAssignments || [];

    const roleAssignmentsResponse = [
    ...mainRoleAssignments,
    ...subRoleAssignments];


    const [privateSettings] = roleAssignmentsResponse.filter(
      ({ isPrivate: hasPrivateRoleAssignment }) => hasPrivateRoleAssignment
    );

    return void this.setState({
      privateSettings,
      privateSettingsModalVisible: false
    });
  };

  onSaveLinkSharingSettings = async () => {
    const {
      draftLinkSharingSettings: {
        publicSettings,
        workspaceSettings: {
          resourceRoleAssignmentId,
          canSearch,
          role: { roleId }
        }
      },
      guestRole,
      noneRole,
      organisationId,
      privateSettings
    } = this.state;

    const {
      updateRoleAssignments,
      resourceId,
      resourceName,
      resourceSubId,
      resourceSubName
    } = this.props;

    const assignmentsToUpsert = [
    {
      resourceRoleAssignmentId,
      public: false,
      canSearch,
      roleId,
      organisationId
    },
    {
      resourceRoleAssignmentId: publicSettings.resourceRoleAssignmentId,
      public: true,
      roleId: publicSettings.role.roleId,
      organisationId: null,
      ...(publicSettings.password !== void 0 ?
      { password: publicSettings.password } :
      {})
    }];


    const mainRequest = updateRoleAssignments({
      assignmentsToUpsert,
      resourceId,
      resourceType: resourceName
    });

    const subRequest = resourceSubId && resourceSubName ?
    updateRoleAssignments({
      assignmentsToUpsert,
      resourceId: resourceSubId,
      resourceType: resourceSubName
    }) :
    null;

    const [mainResponse, subResponse] = await Promise.all([
    mainRequest,
    subRequest]
    );

    const { data: mainData, error: mainError } = mainResponse;
    const { data: subData, error: subError } = subResponse || {};

    if (mainError || resourceSubId && subError) {
      return;
    }

    if (privateSettings && privateSettings.resourceRoleAssignmentId) {
      const privateDeleteRequest = updateRoleAssignments({
        assignmentIdsToDelete: [privateSettings.resourceRoleAssignmentId],
        resourceId,
        resourceType: resourceName
      });

      const subPrivateDeleteRequest = resourceSubId && resourceSubName ?
      updateRoleAssignments({
        assignmentIdsToDelete: [privateSettings.resourceRoleAssignmentId],
        resourceId: resourceSubId,
        resourceType: resourceSubName
      }) :
      null;

      await Promise.all([privateDeleteRequest, subPrivateDeleteRequest].filter(Boolean));
    }

    const combinedAssignments = [
    ...(mainData?.updateRoleAssignments || []),
    ...(subData?.updateRoleAssignments || [])];


    const linkSharingSettings = getLinkSharingSettings(
      combinedAssignments,
      guestRole,
      noneRole
    );
    const updatedPrivateSettings = getPrivateResourceSettings(
      combinedAssignments
    );

    this.setState({
      linkSharingSettings,
      draftLinkSharingSettings: linkSharingSettings,
      privateSettings: updatedPrivateSettings
    });
  };

  onChangeLinkShareSettings = (updatedSettings) => {
    const { organisationId } = this.state;
    this.setState(
      ({ draftLinkSharingSettings }) => ({
        draftLinkSharingSettings: {
          ...draftLinkSharingSettings,
          ...updatedSettings,
          workspaceSettings: {
            ...draftLinkSharingSettings?.workspaceSettings,
            ...updatedSettings.workspaceSettings,
            organisationId
          }
        }
      }),
      this.onSaveLinkSharingSettings
    );
  };

  onRemoveMember = (draftMemberId) => () => {
    this.setState(
      ({
        draftMembers: prevDraftMembers = [],
        deletedMembers: prevDeletedMembers = new Set(),
        draftSubMembers: prevDraftSubMembers = [],
        deletedSubMembers: prevDeletedSubMembers = new Set()
      }) => {
        const newMembers = _cloneDeep(prevDraftMembers);
        const newDeletedMembers = _cloneDeep(prevDeletedMembers);
        const newSubMembers = _cloneDeep(prevDraftSubMembers);
        const newDeletedSubMembers = _cloneDeep(prevDeletedSubMembers);

        const memberToDelete = prevDraftMembers.find(
          (member) => member.draftMemberId === draftMemberId
        );
        const subMemberToDelete = prevDraftSubMembers.find(
          (member) => member?.email === memberToDelete?.email
        );

        if (memberToDelete) {
          newDeletedMembers.add(memberToDelete);
        }

        if (subMemberToDelete) {
          newDeletedSubMembers.add(subMemberToDelete);
        }

        return {
          draftMembers: newMembers.filter(
            (member) => member.draftMemberId !== draftMemberId
          ),
          deletedMembers: newDeletedMembers,
          draftSubMembers: newSubMembers.filter(
            (member) => member?.email !== memberToDelete?.email
          ),
          deletedSubMembers: newDeletedSubMembers
        };
      }
    );
  };

  onUpdateMember = (draftMemberId, updatedMember) => {
    this.setState(({ draftMembers: prevDraftMembers, draftSubMembers: prevDraftSubMembers }) => {
      const updateList = (list) => _cloneDeep(list).map((member) => {
        if (member.email !== updatedMember.email) {
          return member;
        }
        return { ...member, role: updatedMember.role };
      });
      return {
        draftMembers: updateList(prevDraftMembers),
        draftSubMembers: updateList(prevDraftSubMembers)
      };
    });
  };

  onAddMember = (addedMember) => {
    this.setState(({ draftMembers: prevDraftMembers,
      draftSubMembers: prevDraftSubMembers, guestRole }) => {
      const newDraftMember = {
        ...addedMember,
        role: guestRole,
        draftMemberId: addedMember.resourceRoleAssignmentId || uuid()
      };

      const newDraftSubMember = {
        ...addedMember,
        role: guestRole,
        draftSubMemberId: addedMember.resourceRoleAssignmentId || uuid()
      };

      return {
        draftMembers: [..._cloneDeep(prevDraftMembers), newDraftMember],
        draftSubMembers: [..._cloneDeep(prevDraftSubMembers), newDraftSubMember]
      };
    });
  };

  getUsers = async (...args) => {
    const { getUsersByName, apiClient } = this.props;
    const { organisationId } = this.state;
    const { data, error } = await getUsersByName(...args);

    if (!data || !data.getUsersByName || error) {
      return { data, error };
    }

    const users = await resolveProfileImages(
      data.getUsersByName,
      organisationId,
      apiClient
    );

    return { data: { getUsersByName: users } };
  };

  render() {
    const {
      children,
      getTeamsByName,
      resourceId,
      resourceName,
      shareUrl,
      workflowV5 = false,
      authorities = [],
      apiClient
    } = this.props;
    const {
      draftMembers = [],
      members,
      organisationId,
      collaborationModalVisible,
      shareModalVisible,
      draftLinkSharingSettings,
      linkSharingSettings,
      privateSettings,
      privateSettingsModalVisible,
      roles = []
    } = this.state;

    return (
      <CollaborationProviderContext
        value={this.getProviderValue(members, privateSettings, resourceName, linkSharingSettings)}>

        <>
          {children}
          {workflowV5 ?
          <CollaborationModalV5
            authorities={authorities}
            visible={collaborationModalVisible}
            members={draftMembers}
            organisationId={organisationId}
            resourceId={resourceId}
            roles={roles}
            onClose={this.hideCollaborationModal}
            getUsersByName={this.getUsers}
            getTeamsByName={getTeamsByName}
            onUpdateAndSaveMembers={this.onUpdateAndSaveMembers}
            onRemoveMember={this.onRemoveMember}
            onUpdateMember={this.onUpdateMember}
            onAddMember={this.onAddMember}
            apiClient={apiClient} /> :


          <CollaborationModal
            visible={collaborationModalVisible}
            members={draftMembers}
            organisationId={organisationId}
            resourceId={resourceId}
            roles={roles}
            onClose={this.hideCollaborationModal}
            getUsersByName={this.getUsers}
            getTeamsByName={getTeamsByName}
            onUpdateAndSaveMembers={this.onUpdateAndSaveMembers}
            onRemoveMember={this.onRemoveMember}
            onUpdateMember={this.onUpdateMember}
            onAddMember={this.onAddMember} />}



          {draftLinkSharingSettings ?
          <ShareModal
            onSaveLinkSharingSettings={this.onSaveLinkSharingSettings}
            onChangeLinkShareSettings={this.onChangeLinkShareSettings}
            organisationId={organisationId}
            visible={shareModalVisible}
            roles={roles}
            onClose={this.hideShareModal}
            resourceName={resourceName}
            linkSharingSettings={draftLinkSharingSettings}
            shareUrl={shareUrl} /> :

          null}
          <PrivateSettingsModal
            visible={privateSettingsModalVisible}
            privateResource={privateSettings && privateSettings.isPrivate}
            handleUpdate={this.onUpdatePrivateSettings}
            hideModal={this.hidePrivateSettingsModal}
            resourceName={resourceName} />

        </>
      </CollaborationProviderContext>);

  }
}